import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { eventFindInPath, isEqual } from '@fi-shared/utils';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { DocumentItemViewComponent } from '../item-view/item-view.component';
import { DocumentEditService } from '../document-edit.service';
import { TemplateLayoutModel } from '@fi-app/template/template-layout.model';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { BaseItemModelService } from '@fi-app/template/base-item.model';

@Component({
    selector: 'fi-document-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    host: { class: 'fi-document-layout' },
})
export class DocumentLayoutComponent implements OnInit {
    @Input() tplLayout: TemplateLayoutModel;
    @Input() disableEdit: boolean = false;
    @Input() device: number = 800;
    @Input() languageId: number;
    @Input() compareWithLayout?: DocumentLayoutComponent;

    @Output('mediaBankFileChanged') mediaBankFileChangedEmitter = new EventEmitter<any>();
    @Output() contentChange = new EventEmitter();
    @Output() afterViewRendered = new EventEmitter();

    @ViewChildren(DocumentItemViewComponent) items: QueryList<DocumentItemViewComponent>;
    mouseClickEvent: MouseEvent;

    constructor(
        private detectDevices: DetectDevicesService,
        private documentEditService: DocumentEditService,
    ) {}

    initialItemsCount: number = 0;

    isItemSelected(item: BaseItemModelService) {
        return isEqual(this.tplLayout.selectedItem, item) && !this.disableEdit;
    }

    isItemSelectedColumn(item: BaseItemModelService, columnNumber: number) {
        return this.isItemSelected(item) && item.EditColumn === columnNumber;
    }

    ngOnInit() {
        this.initialItemsCount = this.getViewItemsCount();
    }

    getViewItemsCount() {
        let result = 0;
        this.tplLayout.placeholders.forEach((placeholder) => {
            if (placeholder.children && placeholder.children.length > 0) {
                placeholder.children.forEach((child) => (result += child.items.length));
            } else {
                result += placeholder.items.length;
            }
        });
        return result;
    }

    isEmptyItem(item: BaseItemModelService) {
        return item.IsEmpty(this.languageId);
    }

    layoutItemColumnClick($event) {
        setTimeout(() => {
            // hiding a PageHeader element, that will render an empty space on visual DOM that allow to raice up an item(image)
            if (this.detectDevices.isMobilePhone() && $event.item.type == 'image') {
                // element.closest('.Ccm-Page-Document-Edit').find('.Ccm-PageHeader-DocumentEdit').addClass('hide');
            }

            if (!$event.item.isLocked()) {
                if (this.tplLayout.selectedItem && $event.item !== this.tplLayout.selectedItem)
                    this.tplLayout.selectedItem.EditColumn = false;

                this.tplLayout.selectedItem = $event.item;
                this.tplLayout.selectedColumn = $event.column;

                if (this.disableEdit !== true) this.tplLayout.selectedItem.EditColumn = this.tplLayout.selectedColumn;
            }
        });
    }

    @HostListener('document:click', ['$event'])
    clickDocument(event: MouseEvent) {
        this.mouseClickEvent = event;
        // do not close editor when text selecting started in text editor and finished outside
        if (!this.tplLayout.selectedItem || this.documentEditService.MouseDownOnText) return;

        // do not close editor when overlay operation opened
        // TODO: remove '.operation-overlay-small', '.operation-overlay-large' after we get rid of it
        const ignoreClasses = [
            '.operation-overlay-small',
            '.operation-overlay-large',
            '.document-edit-no-close',
            '.template-item',
            '.modal',
            'input[type="file"]',
            '.mat-dialog-container',
            '.cdk-overlay-pane',
            '.cdk-overlay-backdrop',
            '.fi-dropdown-items',
        ];

        if (!ignoreClasses.some((ic) => !!eventFindInPath(event, ic))) {
            this.tplLayout.selectedItem.EditColumn = false;
            this.tplLayout.selectedItem = false;
        }
    }

    onMediaBankFileChanged($event) {
        this.mediaBankFileChangedEmitter.emit($event);
    }

    documentEditItemContentChange($event) {
        this.contentChange.emit($event);
    }

    getCompareItem(item: DocumentItemViewComponent) {
        if (!this.compareWithLayout || !this.compareWithLayout.items || !this.items) return;

        const i = this.items.toArray().indexOf(item);
        return this.compareWithLayout.items.toArray()[i];
    }

    renderedCount: number = 0;

    itemAfterRender() {
        this.renderedCount++;
        if (this.renderedCount === this.initialItemsCount) this.afterViewRendered.emit();
    }

    isItemLocked(item) {
        return item.model.Settings.lock === true;
    }
}
